<template>
  <div class="editPassword">
    <!-- 修改密码对话框 -->
    <el-dialog :visible.sync="dialogVisible" top="32vh" :before-close="closeDialog" :close-on-click-modal="false">
      <div slot="title" class="el-dialog__title"><div class="title-left"></div><slot name="title">{{$t('personCenterV2.editPass')}}</slot><div class="title-right"></div></div>
      <!-- 表单区域 -->
      <el-form :model="ruleForm" :hide-required-asterisk="true" :rules="passwordRules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item :label="$t('personCenterV2.originalPass')" prop="oldPassword">
          <el-input type="password" v-model.trim="ruleForm.oldPassword" :placeholder="$t('personCenterV2.oldPass')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('personCenterV2.newCode')" prop="password">
          <el-input type="password" v-model.trim="ruleForm.password" :placeholder="$t('personCenterV2.newPass')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('personCenterV2.verifyPass')" prop="checkPassword">
          <el-input type="password" v-model.trim="ruleForm.checkPassword" :placeholder="$t('personCenterV2.surePass')"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()" class="btn_cancle">{{ $t('personCenterV2.cancle') }}</el-button>
        <el-button type="primary" v-preventReClick="2000" @click="sureDialog()">{{ $t('personCenterV2.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 返回登录页 -->
    <logOut :dialogVisible="logOutDialog" :count="count"></logOut>
  </div>
</template>

<script>
// 重置密码 接口
import { resetPassword } from '@/services/userInfo';
import { logoutAjax } from '@/services/loginRegister';
import { clearCookies } from '@/services/common';

import md5 from 'js-md5';
import logOut from '../louOut';

export default {
  name: 'editPassword',
  components: {
    logOut,
  },

  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    oldPassInfo: Object,
  },
  data() {
    // 自定义校验密码
    var password = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t("personCenterV2.oldPassWordEmpty")))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      const newPassword = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z_]{6,16}$/g
      if (value === '') {
        callback(new Error(this.$t("personCenterV2.newPassWordEmpty")))
      } else if (!newPassword.test(value)) {
        callback(new Error(this.$t("personCenterV2.passWordFormat")))
      } else if (value === this.ruleForm.oldPassword) {
        callback(new Error(this.$t("personCenterV2.passwordVary")))
      }
      callback()
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t("personCenterV2.confirmPassWord")))
      } else if (value !== this.ruleForm.password) {
        callback(new Error(this.$t("personCenterV2.InconsistentNewPassword")))
      }
      callback()
    }
    return {
      //   表单数据源
      ruleForm: {
        loginPhone: '', //用户名
        oldPassword: '', //原密码   md5
        password: '', // 新密码  md5
        checkPassword: '', //确认密码  md5
      },
      //   表单验证
      passwordRules: {
        oldPassword: [{ required: true, validator: password, trigger: 'blur' }],
        password: [{ required: true, validator: validatePass, trigger: 'blur' }],
        checkPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
      logOutDialog: false, //退出登录页对话框
      count: 0, //倒计时
      closeLogOutDialog: false,
      CAS_ENABLE: CAS_ENABLE,
    }
  },
  methods: {
    // 关闭重置表单
    closeDialog() {
      this.$refs.ruleForm.resetFields()
      this.$emit('closeEditPassword')
    },
    // 关闭密码对话框
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.$emit('closeEditPassword')
    },

    // 确认按钮，更新密码
    sureDialog() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const res = await resetPassword({
          loginPhone: this.ruleForm.loginPhone,
          oldPassword: md5(this.ruleForm.oldPassword),
          password: md5(this.ruleForm.password),
        })
        if (res.success) {
          this.$emit('closeEditPassword')
          this.logOutDialog = true
          const TIME_COUNT = 3
          if (!this.timer) {
            this.count = TIME_COUNT
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                clearInterval(this.timer)
                this.timer = null;

                // 跳转的页面写在此处
                let self = this;
                if (this.CAS_ENABLE) {
                  localStorage.removeItem('myHeaderUser');
                  localStorage.removeItem('myUser');
                  let callback = encodeURIComponent(`${window.location.origin}/logout?client_name=${CAS_CLIENT_NAME}`);
                  window.location.href = `${CAS_LOGOUT_URL}?service=${callback}`;
                  clearCookies();
                  localStorage.clear();
                  sessionStorage.clear();
                } else {
                  logoutAjax(Object()).then(function (resp) {
                    if (resp.status === 200 && resp.success) {
                      clearCookies();
                      localStorage.clear();
                      // localStorage.removeItem('userInfo');
                      // localStorage.removeItem('myUser');
                      // localStorage.removeItem('companyCode');
                      // localStorage.removeItem('myCompanyCode');
                      // localStorage.removeItem('theme');
                      sessionStorage.clear();
                      self.$router.push({ name: 'login' });
                    }
                  });
                }

              }
            }, 1000)
          }
        }
      })
    },
  },
  watch: {
    oldPassInfo: function (val) {
      this.ruleForm.loginPhone = val.email //用户名
    },
  },
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
